module.exports = __webpack_public_path__ + "img/bottomLogo.303924b4.png";